<template>
    <div>
        <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">{{ sender ? sender.name : 'Uni-Truths' }}</h5>
            <span>
                <!-- convert this expiry time to human readable time until -->
                <!-- <small class="text-secondary pr-3">{{ bulletin.expiry_time ? Carbon\Carbon::parse($bulletin->expiry_time, 'UTC')->diffForHumans() : '' }}</small> -->
                
                <small class="text-secondary pr-3">{{ expiry_time }}</small>
                <a v-if="dismissable" href="#" class="text-secondary"
                @click="dismiss(id)"><i
                class="fas fa-times-circle"></i>
                </a>
                <a v-else href="#" class="text-white"><i
                    class="fas fa-times-circle"></i>
                </a>
            </span>
        </div>
        <!-- <p class="mb-1">{!! strip_tags(nl2br($bulletin->text), config('sanitization.html_allowed_tags')) !!}</p> -->
        <!-- Strip bad tags. -->
        <p class="mb-1" style="white-space: pre-line;">{{ text }}</p>
    </div>
</template>

<script>
export default {
    name: "Bulletin",

    props: {
        id: {
            type: Number,
        },
        sender: {
            type: String,
        },
        expiry_time: {},
        dismissable: {
            type: Boolean,
        },
        text: {
            type: String,
        },
    },

    data() {
        return {}
    },

    methods: {
        dismiss(bulletinId) {
            let self = this;
            axios.post('api/bulletin/' + bulletinId + '/dismiss')
            .then(function (response) {
                self.$emit("bulletin-dismissed", self);
            })
            .catch(function (error) {
                console.log(error);
            });
        },
    },
}
</script>